module.exports = __webpack_public_path__ + "static/img/w-6.71cd137.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/worldView/w-6.jpg
// module id = xgIi
// module chunks = 1